import { Injectable } from '@angular/core';
import { ProductApi } from '@app/models/product-api-management/product-api.model';
import { HttpClient } from "@angular/common/http";
import { ProductApiMappedField } from '@app/models/product-api-management/product-api-mapped-field.model';
import { ProductApiGrid } from '@app/models/product-api-management/product-api-grid.model';
import { ProductApiGridFilter } from '@app/models/product-api-management/product-api-grid-filter.model';
import { ProductApiGridCell } from '@app/models/product-api-management/product-api-grid-cell.model';
import { ProductApiGridRow } from '@app/models/product-api-management/product-api-grid-row.model';
import { ProductApiDeviceTypeMapping } from '@app/models/product-api-management/product-api-device-type-mapping.model';
import { ProductApiDeviceTypeMappingSetup } from '@app/models/product-api-management/product-api-device-type-mapping-setup.model';
import { ProductApiFilter } from '@app/models/product-api-management/product-api-filter.model';
import { ProductApiImportHistory } from '@app/models/product-api-management/product-api-import-history.model';

@Injectable({
  providedIn: 'root'
})
export class ProductApiManagementService {

  private service = "productApiManagementService";

  constructor(private http: HttpClient) { }

  public getProductApis() {
    return this.http.get<ProductApi[]>(
      `api/${this.service}/getProductApis`,
      {
        responseType: "json",
      }
    );
  }
  public getProductApi(id: number) {
    return this.http.get<ProductApi>(
      `api/${this.service}/getProductApi/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getProductApiProducts(id: number) {
    return this.http.get<ProductApi>(
      `api/${this.service}/getProductApiProducts/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public saveProductApi(productApi: ProductApi) {
    return this.http.post<ProductApi>(`api/${this.service}/saveProductApi`, productApi, {
      responseType: "json",
    });
  }

  public saveProductApiMappedFields(productApi: ProductApi) {
    return this.http.post<ProductApi>(`api/${this.service}/saveProductApiMappedFields`, productApi, {
      responseType: "json",
    });
  }

  public getProductApiMappedFieldsFromUrl(productApi: ProductApi) {
    return this.http.post<ProductApi>(`api/${this.service}/getProductApiMappedFieldsFromUrl`, productApi, {
      responseType: "json",
    });
  }

  public importProductApiProducts(id: number) {
    return this.http.get<number>(
      `api/${this.service}/importProductApiProducts/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getProductApiMappedFields(id: number) {
    return this.http.get<ProductApi>(
      `api/${this.service}/getProductApiMappedFields/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getProductApiDeviceTypeMappings(id: number) {
    return this.http.get<ProductApiDeviceTypeMappingSetup>(
      `api/${this.service}/getProductApiDeviceTypeMappings/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public getProductApiImportHistory(id: number) {
    return this.http.get<ProductApiImportHistory[]>(
      `api/${this.service}/getProductApiImportHistory/${id}`,
      {
        responseType: "json",
      }
    );
  }

  public saveProductApiProductToDnaProduct(productApiId: number, productApiProductId: number, dnaClientId: number, deviceTypeId: number, deviceId: number) {
    return this.http.get<number>(
      `api/${this.service}/saveProductApiProductToDnaProduct/${productApiId}/${productApiProductId}/${dnaClientId}/${deviceTypeId}/${deviceId}`,
      {
        responseType: "json",
      }
    );
  }

  public getProductApiGrid(productApiGridFilter: ProductApiGridFilter) {
    return this.http.post<ProductApiGrid>(
      `api/${this.service}/getProductApiGrid`, productApiGridFilter,
      {
        responseType: "json",
      }
    );
  }

  public saveProductApiDeviceTypeMapping(productApiDeviceTypeMapping: ProductApiDeviceTypeMapping) {
    return this.http.post<ProductApiDeviceTypeMappingSetup>(
      `api/${this.service}/saveProductApiDeviceTypeMapping`, productApiDeviceTypeMapping,
      {
        responseType: "json",
      }
    );
  }

  public deleteProductApiDeviceTypeMapping(productApiDeviceTypeMapping: ProductApiDeviceTypeMapping) {
    return this.http.post<ProductApiDeviceTypeMappingSetup>(
      `api/${this.service}/deleteProductApiDeviceTypeMapping`, productApiDeviceTypeMapping,
      {
        responseType: "json",
      }
    );
  }

  public deleteProductApiMappedField(productApiMappedField: ProductApiMappedField) {
    return this.http.post<ProductApi>(
      `api/${this.service}/deleteProductApiMappedField`, productApiMappedField,
      {
        responseType: "json",
      }
    );
  }

  public saveProductApiProductFieldValue(productApiGridCell: ProductApiGridCell) {
    return this.http.post<ProductApiGridRow>(
      `api/${this.service}/saveProductApiProductFieldValue`, productApiGridCell,
      {
        responseType: "json",
      }
    );
  }

  public saveProductApiProductCustomFieldValue(productApiGridCell: ProductApiGridCell) {
    return this.http.post<ProductApiGridRow>(
      `api/${this.service}/saveProductApiProductCustomFieldValue`, productApiGridCell,
      {
        responseType: "json",
      }
    );
  }

  public getProductApisByFilter(productApiFilter: ProductApiFilter) {
    return this.http.post<ProductApi[]>(
      `api/${this.service}/getProductApisByFilter`, productApiFilter,
      {
        responseType: "json",
      }
    );
  }

  public validateProductApi(productApi: ProductApi) {
    return this.http.post<string[]>(`api/${this.service}/validateProductApi`, productApi, {
      responseType: "json",
    });
  }
}
